import axios from "axios";
import { set } from "date-fns";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useOutletContext, useParams } from "react-router-dom";
import Select from "react-select";
import toastr from "../../utils/toast";
import useSmartBack from "../../hooks/useSmartBack";

export default function SearchUniverse() {
  const { id } = useParams();
  const [step, setStep] = useState(1);
  const [search, setSearch] = useState("");
  const [searchCountry, setSearchCountry] = useState("");
  const [dataindustries, setDataIndustries] = useState([]);
  const [dataregions, setDataRegions] = useState([]);
  const REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PINE_BASE_URL = process.env.REACT_APP_PINE_BASE_URL;
  const { setGlobalLoading, token } = useOutletContext();
  const [updatedIndustries, setUpdatedIndustries] = useState([]);
  const [updatedCountries, setUpdatedCountries] = useState([]);
  const [companyRevenue, setCompanyRevenue] = useState([]);
  const [companySizes, setCompanySizes] = useState([]);

  const [companies, setCompanies] = useState([]);
  const [totalCompanies, setTotalCompanies] = useState(0);
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);

  // Filters
  const [revenueFilter, setRevenueFilter] = useState([]);
  const [sizeFilter, setSizeFilter] = useState([]);
  const [appliedFilters, setAppliedFilters] = useState({});

  const [companyInput, setCompanyInput] = useState("");
  const [companyNames, setCompanyNames] = useState([]);

  const [ContactSeniority, setContactSeniority] = useState([]);
  const [ContactDepartments, setContactDepartments] = useState([]);

  const [SelectedContacts, setSelectedContacts] = useState([]);
  const [SuggestionLoader, setSuggestionLoader] = useState(false);
  const [JdLoader, setJdLoader] = useState(false);

  const [jobTitles, setJobTitles] = useState("");
  const [jobNames, setJobNames] = useState([]);
  const handleBack = useSmartBack(`/workstation/view/${id}`);

  const handleRevenueChange = (options) => {
    setRevenueFilter(options?.map((o) => o.value) || []);
  };

  const handleSizeChange = (options) => {
    setSizeFilter(options?.map((o) => o.value) || []);
  };

  const common_api_ref = useRef();

  const {
    register,
    handleSubmit,
    trigger,
    setValue,
    setError,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onSubmit",
    reValidateMode: "onChange",
    shouldUnregister: false,
    defaultValues: {
      industries: [],
      companies: 0,
      countries: [],
      seniority: [],
      departments: [],
    },
  });

  const selectedIndustries = watch("industries");
  const selectedCountries = watch("countries");
  const selectedSeniority = watch("seniority");
  const selectedDepartments = watch("departments");

  const [contacts, setContacts] = useState([]);
  const [backupContacts, setBackupContacts] = useState([]);
  const [requestId, setRequestId] = useState(null);
  const [totalContacts, setTotalContacts] = useState(0);
  const [contactPage, setContactPage] = useState(0);
  const [hasMoreContacts, setHasMoreContacts] = useState(true);
  const [contactLoading, setContactLoading] = useState(false);
  const [contactFilters, setContactFilters] = useState(null);
  const [DisableShowDetails, setDisableShowDetails] = useState(false);
  const [generatedRoleDescription, setGeneratedRoleDescription] = useState("");
  const [savedSearch, setSavedSearch] = useState(null);

  const toggle = (value) => {
    const current = selectedIndustries || [];

    const updated = current.includes(value)
      ? current.filter((v) => v !== value)
      : [...current, value];

    setValue("industries", updated, { shouldValidate: true });
    setUpdatedIndustries(updated);
  };

  const toggleCountries = (value) => {
    const current = selectedCountries || [];

    const updated = current.includes(value)
      ? current.filter((v) => v !== value)
      : [...current, value];

    setValue("countries", updated, { shouldValidate: true });
    setUpdatedCountries(updated);
  };

  const toggleRegion = (regionName) => {
    const regionCountries =
      dataregions[regionName]?.map((c) => c.country) || [];

    const current = selectedCountries || [];

    const allSelected = regionCountries.every((c) => current.includes(c));

    const updated = allSelected
      ? current.filter((c) => !regionCountries.includes(c))
      : Array.from(new Set([...current, ...regionCountries]));

    setValue("countries", updated, { shouldValidate: true });
    setUpdatedCountries(updated);
  };

  const toggleSeniority = (value) => {
    const current = selectedSeniority || [];

    const updated = current.includes(value)
      ? current.filter((v) => v !== value)
      : [...current, value];

    setValue("seniority", updated, { shouldValidate: true });
  };

  const toggleDepartments = (value) => {
    const current = selectedDepartments || [];

    const updated = current.includes(value)
      ? current.filter((v) => v !== value)
      : [...current, value];

    setValue("departments", updated, { shouldValidate: true });
  };

  const industry_master = () => {
    try {
      fetch(`${REACT_APP_API_BASE_URL}/lusha/lusha_industries`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
        .then((res) => res.json())
        .then((data) => {
          setDataIndustries(data);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const region_country = () => {
    try {
      fetch(`${REACT_APP_API_BASE_URL}/lusha/country_region_map`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
        .then((res) => res.json())
        .then((data) => {
          const regionWise = data.reduce((acc, curr) => {
            const region = curr.region_name;

            if (!acc[region]) {
              acc[region] = [];
            }

            acc[region].push({
              country_id: curr.country_id,
              country: curr.country,
              country_code: curr.country_code,
            });

            return acc;
          }, {});
          setDataRegions(regionWise);
        });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (common_api_ref.current) return;
    common_api_ref.current = true;
    industry_master();
    company_filters();
    region_country();
    contact_filters();
  }, []);

  const industriesTree = useMemo(() => {
    if (!dataindustries?.length) return [];

    const map = {};

    dataindustries.forEach((item) => {
      const group = item.name;
      const main = item.main_industry;

      if (!map[group]) {
        map[group] = {
          label: group,
          mains: {},
        };
      }

      if (!map[group].mains[main]) {
        map[group].mains[main] = {
          label: main,
          subs: [],
        };
      }

      map[group].mains[main].subs.push({
        id: item.lusha_industry_id,
        label: item.sub_industry,
      });
    });

    // convert object → array
    return Object.values(map).map((g) => ({
      ...g,
      mains: Object.values(g.mains),
    }));
  }, [dataindustries]);

  const filteredIndustries = useMemo(() => {
    if (!search) return industriesTree;

    const q = search.toLowerCase();

    return industriesTree
      .map((group) => {
        // 1️⃣ Group match → return full group
        if (group.label.toLowerCase().includes(q)) {
          return group;
        }

        const mains = group.mains
          .map((main) => {
            // 2️⃣ Main match → return full main with all subs
            if (main.label.toLowerCase().includes(q)) {
              return main;
            }

            // 3️⃣ Sub match → return only matching subs
            const subs = main.subs.filter((s) =>
              s.label.toLowerCase().includes(q),
            );

            return subs.length ? { ...main, subs } : null;
          })
          .filter(Boolean);

        return mains.length ? { ...group, mains } : null;
      })
      .filter(Boolean);
  }, [search, industriesTree]);

  const industryIdMap = useMemo(() => {
    const map = {};
    industriesTree.forEach((g) =>
      g.mains.forEach((m) =>
        m.subs.forEach((s) => {
          map[s.id] = s.label;
        }),
      ),
    );
    return map;
  }, [industriesTree]);

  const filteredCountriesByRegion = Object.entries(dataregions || {})
    .map(([regionName, countries]) => {
      const filtered = countries.filter((item) =>
        item.country.toLowerCase().includes(searchCountry.toLowerCase()),
      );

      return {
        region: regionName,
        countries: filtered.map((item) => ({
          value: item.country_id,
          label: item.country,
          code: item.country_code,
        })),
      };
    })
    .filter((r) => r.countries.length > 0); // remove empty regions

  const steps = [
    {
      id: 1,
      label: "Industries",
      icon: "fa-solid fa-building",
      fields: ["industries"],
    },
    {
      id: 2,
      label: "Companies",
      icon: "fa-solid fa-briefcase",
      fields: ["companies"],
    },
    {
      id: 3,

      label: "Geographies",
      icon: "fa-solid fa-globe",
      fields: ["countries"],
    },
    {
      id: 4,
      label: "Functions",
      icon: "fa-solid fa-user-tie",
      fields: ["seniority", "departments"],
    },
  ];

  const goToStep = async (nextStep) => {
    const currentFields = steps.find((s) => s.id === step)?.fields;
    const valid = await trigger(currentFields);
    if (valid) {
      setStep(nextStep);
    }
    window.scrollTo(0, 0);
  };

  const company_filters = async () => {
    try {
      const response = await Promise.all([
        axios.get(`${REACT_APP_API_BASE_URL}/lusha/company_filter_revenue`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }),
        axios.get(`${REACT_APP_API_BASE_URL}/lusha/company_filter_sizes`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }),
      ]);
      setCompanyRevenue(response[0].data);
      setCompanySizes(response[1].data);
    } catch (error) {
      console.log(error);
    } finally {
    }
  };

  const contact_filters = async () => {
    try {
      const response = await Promise.all([
        axios.get(`${REACT_APP_API_BASE_URL}/lusha/contact_filter_seniority`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }),
        axios.get(
          `${REACT_APP_API_BASE_URL}/lusha/contact_filter_departments`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          },
        ),
      ]);
      console.log(response[0].data);
      console.log(response[1].data);
      setContactSeniority(response[0].data);
      setContactDepartments(response[1].data);
    } catch (error) {
      console.log(error);
    }
  };

  const formatAmount = (num) => {
    if (!num) return "";

    if (num >= 1_000_000_000)
      return `$${(num / 1_000_000_000).toString().replace(/\.0$/, "")}B`;
    if (num >= 1_000_000)
      return `$${(num / 1_000_000).toString().replace(/\.0$/, "")}M`;
    if (num >= 1_000)
      return `$${(num / 1_000).toString().replace(/\.0$/, "")}K`;

    return `$${num}`;
  };

  const cr_options = companyRevenue.map((item) => {
    const minLabel = formatAmount(item.min);
    const maxLabel = item.max ? formatAmount(item.max) : null;

    return {
      value: `${item.min}-${item.max || ""}`,
      label: maxLabel ? `${minLabel} - ${maxLabel}` : `${minLabel}+`,
    };
  });

  const sz_options = companySizes.map((item) => ({
    value: `${item.min}-${item.max || ""}`,
    label: `${item.min}${item.max ? ` - ${item.max}` : "+"}`,
  }));

  const getAllSubsFromMains = (mains = []) =>
    mains.flatMap((m) => m.subs || []);

  const getSelectedCount = (subs = []) =>
    subs.filter((s) => selectedIndustries?.includes(s.id)).length;

  const isAllSelected = (subs) =>
    subs.every((s) => selectedIndustries?.includes(s.id));

  const isSomeSelected = (subs) =>
    subs.some((s) => selectedIndustries?.includes(s.id));

  const isAllMajorSelected = (mains) => {
    const allSubs = getAllSubsFromMains(mains);
    return allSubs.length > 0 && isAllSelected(allSubs);
  };

  const toggleMajor = (mains) => {
    const allSubs = getAllSubsFromMains(mains);
    toggleMain(allSubs);
  };

  const toggleMain = (subs) => {
    const ids = subs.map((s) => s.id);
    const current = selectedIndustries || [];

    const allSelected = ids.every((id) => current.includes(id));

    const updated = allSelected
      ? current.filter((id) => !ids.includes(id)) // unselect all
      : Array.from(new Set([...current, ...ids])); // select all

    setValue("industries", updated, { shouldValidate: true });
    setUpdatedIndustries(updated);
  };

  const onSubmit = async (data) => {
    if (data.industries.length === 0) {
      setError("industries", {
        type: "manual",
        message: "Please select at least one industry",
      });
      setStep(1);
      window.scrollTo(0, 0);
      return;
    }
    if (data.companies === 0) {
      setError("companies", {
        type: "manual",
        message: "There must be at least one company in result",
      });
      setStep(2);
      window.scrollTo(0, 0);
      return;
    }
    if (data.countries.length === 0) {
      setError("countries", {
        type: "manual",
        message: "Required",
      });
      setStep(3);
      window.scrollTo(0, 0);
      return;
    }
    if (data.seniority.length === 0) {
      setError("seniority", {
        type: "manual",
        message: "Please select at least one seniority level",
      });
      window.scrollTo(0, 0);
      setStep(4);
      return;
    }

    if (data.departments.length === 0) {
      setError("departments", {
        type: "manual",
        message: "Please select at least one department",
      });
      window.scrollTo(0, 0);
      setStep(4);
      return;
    }

    const filters = {
      industries: data.industries,
      companies: data.companies,
      countries: data.countries,
      seniority: data.seniority,
      departments: data.departments,
      revenues: revenueFilter,
      size: sizeFilter,
      names: companyNames,
    };
    setContactFilters(filters);

    resetContactsState();
    setGlobalLoading(true);
    get_contacts(0, filters);
    setGlobalLoading(false);
    setDisableShowDetails(false);
    setStep(5);
  };

  const get_companies = async (pageNo = 0, filters = {}) => {
    if (loading) return;
    if (pageNo !== 0 && !hasMore) return;
    try {
      setLoading(true);

      const response = await axios.post(
        `${REACT_APP_API_BASE_URL}/lusha/company_search`,
        {
          pages: {
            page: pageNo,
            size: 50,
          },
          filters: {
            industries: updatedIndustries,
            revenues: filters.revenues,
            size: filters.size,
            names: filters.names,
          },
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const result = response.data?.data || [];
      setCompanies((prev) => (pageNo === 0 ? result : [...prev, ...result]));
      setValue("companies", [...result].length, { shouldValidate: true });
      setTotalCompanies(response.data.totalResults);
      if (result.length < 50) {
        setHasMore(false);
      }

      setPage(pageNo + 1);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!jobTitles.trim() && backupContacts.length) {
      setContacts(backupContacts);
      setJobNames([]);
    }
  }, [jobTitles]);

  const get_contacts = async (pageNo = 0, filters, replace = false) => {
    if (!replace && pageNo !== 0 && (contactLoading || !hasMoreContacts))
      return;

    try {
      setContactLoading(true);

      const resp = await axios.post(
        `${REACT_APP_API_BASE_URL}/lusha/contact_search`,
        {
          pages: { page: pageNo, size: 50 },
          filters,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      const result = resp.data?.data || [];
      setRequestId(resp.data?.requestId);
      setContacts((prev) => (pageNo === 0 ? result : [...prev, ...result]));
      setTotalContacts(resp.data.totalResults);
      setHasMoreContacts(resp.data.hasMore);
      setContactPage(pageNo + 1);
    } catch (err) {
      console.error(err);
    } finally {
      setContactLoading(false);
    }
  };

  const applyFilters = () => {
    const filters = {
      revenues: revenueFilter,
      size: sizeFilter,
    };

    setAppliedFilters(filters);
    setCompanies([]);
    setPage(0);
    setHasMore(true);

    get_companies(0, filters);
  };

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;

    if (scrollHeight - scrollTop <= clientHeight + 50) {
      get_companies(page, appliedFilters);
    }
  };

  const resetFilters = () => {
    setAppliedFilters({});
    setRevenueFilter([]);
    setSizeFilter([]);
    setCompanies([]);
    setPage(0);
    setHasMore(true);
    setLoading(false);

    get_companies(0);
  };

  const removeCompanyName = (name) => {
    const updatedNames = companyNames.filter((n) => n !== name);

    setCompanyNames(updatedNames);

    const updatedFilters = {
      ...appliedFilters,
      names: updatedNames,
    };

    // Remove key if empty
    if (!updatedNames.length) {
      delete updatedFilters.names;
    }

    setAppliedFilters(updatedFilters);
    setCompanies([]);
    setPage(0);
    setHasMore(true);

    get_companies(0, updatedFilters);
  };

  const handleContactScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;

    if (
      scrollHeight - scrollTop <= clientHeight + 50 &&
      !contactLoading &&
      hasMoreContacts &&
      contactFilters
    ) {
      get_contacts(contactPage, contactFilters);
    }
  };

  const handleEnrich = async (contact) => {
    // mark loading on this contact only
    console.log(requestId);
    setContacts((prev) =>
      prev.map((c) =>
        c.contactId === contact.contactId ? { ...c, enrichLoading: true } : c,
      ),
    );
    setDisableShowDetails(true);
    try {
      const resp = await axios.post(
        `${REACT_APP_API_BASE_URL}/lusha/contact_enrich`,
        {
          contactId: contact.contactId,
          requestId: requestId,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      const enrichedData = resp.data || {};

      setContacts((prev) =>
        prev.map((c) =>
          c.contactId === contact.contactId
            ? {
                ...c,
                ...enrichedData,
                enriched: true,
                enrichLoading: false,
              }
            : c,
        ),
      );

      create_candidate(enrichedData, contact);

      if (!enrichedData || Object.keys(enrichedData).length === 0) {
        toastr.error("No enrichment data received");

        setContacts((prev) =>
          prev.map((c) =>
            c.contactId === contact.contactId
              ? { ...c, enrichLoading: false }
              : c,
          ),
        );

        setDisableShowDetails(false);
        return;
      }
    } catch (err) {
      console.error(err);

      setContacts((prev) =>
        prev.map((c) =>
          c.contactId === contact.contactId
            ? { ...c, enrichLoading: false }
            : c,
        ),
      );
    }
  };

  const create_candidate = (lushares, contact) => {
    axios
      .post(
        `${REACT_APP_API_BASE_URL}/lusha/create_candidate`,
        { lushares: lushares },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      )
      .then((resp) => {
        console.log(resp.data);
        setContacts((prev) =>
          prev.map((c) =>
            c.contactId === contact.contactId && !c.candidate_id
              ? {
                  ...c,
                  candidate_id: resp.data.candidate_id,
                  enriched: true,
                  enrichLoading: false,
                }
              : c,
          ),
        );
        setDisableShowDetails(false);
      })
      .catch((err) => {
        toastr.error(err.message);
        setContacts((prev) =>
          prev.map((c) =>
            c.contactId === contact.contactId
              ? { ...c, enrichLoading: false }
              : c,
          ),
        );
      });
  };

  const resetContactsState = () => {
    setContacts([]);
    setContactPage(0);
    setHasMoreContacts(true);
    setContactLoading(false);
    setRequestId(null);
  };

  const toggleAddToWorkstaion = (value) => {
    const current = SelectedContacts || [];

    const updated = current.includes(value)
      ? current.filter((v) => v !== value)
      : [...current, value];

    setSelectedContacts(updated);
  };

  const mapCandidates = async () => {
    const data = {
      selectedId: SelectedContacts,
      selectedRole: id,
    };
    try {
      setGlobalLoading(true);
      const response = await axios.post(
        `${REACT_APP_API_BASE_URL}/ai_candidates/map_to_role`,
        {
          data,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (response.data.success == true) {
        setContacts((prevOptions) =>
          prevOptions.filter(
            (item) => !SelectedContacts.includes(item.candidate_id),
          ),
        );
        setSelectedContacts([]);
        toastr.success(response.data.message);
      } else {
        toastr.error(response.data.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setGlobalLoading(false);
    }

    // Proceed with mapping logic here
  };

  const suggestIndustries = () => {
    const role_description = document.getElementById("role_description").value;

    if (role_description.trim() === "") {
      toastr.error("Please enter a role description.");
      return;
    }
    setSuggestionLoader(true);
    axios
      .post(
        `${REACT_APP_API_BASE_URL}/lusha/suggest_industries`,
        {
          role_description: role_description,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      )
      .then((resp) => {
        const data = resp.data; // [103,133,145]
        console.log(data);
        const current = selectedIndustries || [];

        const updated = [...new Set([...current, ...data])];

        setValue("industries", updated, { shouldValidate: true });
        setUpdatedIndustries(updated);
        setSuggestionLoader(false);
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const getRoleJD = async (id) => {
    try {
      setJdLoader(true);

      const response = await axios.post(
        `${REACT_APP_API_BASE_URL}/workstation/get_role_jd/`,
        {
          role_id: id,
          desc: generatedRoleDescription,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      if (response.data?.error) {
        toastr.error(response.data.message);
      } else {
        setGeneratedRoleDescription(response.data?.role_summary);

        const data = response.data?.search_universer_options?.industries; // [103,133,145]

        const current = selectedIndustries || [];

        const updated = [...new Set([...current, ...data])];

        setValue("industries", updated, { shouldValidate: true });
        setUpdatedIndustries(updated);

        const seniority = response.data?.search_universer_options?.seniority;

        seniority.forEach((s) => {
          toggleSeniority(s);
        });

        const functions =
          response.data?.search_universer_options?.function.split(",");

        functions.forEach((f) => {
          toggleDepartments(f);
        });
      }
    } catch (error) {
      console.log(error);
      toastr.error(error.message);
    } finally {
      setJdLoader(false);
    }
  };

  const saveSearch = async (
    generatedRoleDescription,
    selectedIndustries,
    selectedSeniority,
    selectedDepartments,
    selectedCountries,
  ) => {
    try {
      const response = await axios.post(
        `${REACT_APP_API_BASE_URL}/workstation/save_search/`,
        {
          role_id: id,
          desc: generatedRoleDescription,
          industries: selectedIndustries,
          seniority: selectedSeniority,
          functions: selectedDepartments,
          countries: selectedCountries,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      console.log(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const get_my_saved_search = async () => {
    try {
      const response = await axios.get(
        `${REACT_APP_API_BASE_URL}/workstation/get_my_saved_search/${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      if (response.data.saved_searches) {
        setSavedSearch(response.data.saved_searches);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    get_my_saved_search();
  });

  useEffect(() => {
    if (
      selectedIndustries.length == 0 ||
      selectedDepartments.length == 0 ||
      selectedSeniority.length == 0 ||
      selectedCountries.length == 0
    )
      return;

    saveSearch(
      generatedRoleDescription,
      selectedIndustries,
      selectedSeniority,
      selectedDepartments,
      selectedCountries,
    );
  }, [
    generatedRoleDescription,
    selectedIndustries,
    selectedSeniority,
    selectedDepartments,
    selectedCountries,
  ]);

  const resumeSearch = () => {
    if (!savedSearch) return;
    console.log(savedSearch);
    setGeneratedRoleDescription(savedSearch.description);
    const data = savedSearch.industries; // [103,133,145]

    const current = selectedIndustries || [];

    const updated = [...new Set([...current, ...data])];

    setValue("industries", updated, { shouldValidate: true });
    setUpdatedIndustries(updated);

    const seniority = savedSearch.seniority;
    setValue("seniority", seniority, { shouldValidate: true });

    // functions
    const functions = savedSearch.functions;
    functions.forEach((f) => {
      toggleDepartments(f);
    });

    // countries
    const countries = savedSearch.countries;
    setValue("countries", countries, { shouldValidate: true });
    setUpdatedCountries(countries);
  };

  return (
    <>
      <style>
        {`
        /* Hide default Bootstrap accordion arrow */
        .accordion-button::after {
          display: none;
        }
        .width-100{
          width: 100px !important;
          }
      `}
      </style>
      <div className="d-flex justify-content-end mb-2">
        <button
          className="btn btn-outline-secondary btn-sm d-inline-flex align-items-center"
          style={{
            cursor: "pointer",
            float: "right",
            position: "relative",
            top: "17px",
            right: "24px",
          }}
          onClick={handleBack}
        >
          <i className="ti ti-arrow-left me-1"></i>
          Back To Workstation
        </button>
      </div>

      <div className="content">
        <div
          className="card"
          style={{
            background:
              "radial-gradient(circle, #f265229c 0%, rgba(0, 0, 0, 0) 70%)",
          }}
        >
          <div className="card-body">
            <div className="text-center mb-3">
              <h1 style={{ fontSize: "xxx-large" }}>
                Build Your <span className="text-primary">Search Universe</span>
              </h1>
              <p className="fs-18">
                Define your target market, discover relevant companies with AI,
                and identify
                <br />
                key executives across industries and geographies.
              </p>
            </div>
            <div className="d-flex align-items-center col-md-12 mb-3">
              <div className="col-md-9" style={{ placeItems: "end" }}>
                {/* STEP ICONS */}
                <ul className="nav nav-tabs twitter-bs-wizard-nav justify-content-center">
                  {steps.map((s, i) => (
                    <li
                      className={`nav-item ${i <= 2 ? "me-sm-5" : "me-sm-3"} `}
                      key={s.id}
                    >
                      <button
                        type="button"
                        className={`nav-link border primary-btn-hover radiusBorder-45 border-dark ${
                          step === s.id ? "active bg-primary text-white" : ""
                        }`}
                        onClick={() => setStep(s.id)}
                      >
                        {errors.industries && s.id === 1 ? (
                          <i className="fa-solid fa-asterisk fs-6 float-end text-danger"></i>
                        ) : (
                          ""
                        )}
                        <div className="step-icon">
                          <i className={s.icon}></i>
                        </div>
                        <small>{s.label}</small>
                      </button>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="col-md-3">
                {savedSearch && (
                  <button
                    className="btn btn-secondary float-end"
                    onClick={resumeSearch}
                  >
                    <i className="fa-solid fa-clock-rotate-left me-1"></i>{" "}
                    Resume Search
                  </button>
                )}
              </div>
            </div>
            <div className="card">
              <div className="card-body">
                <form onSubmit={handleSubmit(onSubmit)}>
                  {/* STEP 1 */}
                  {step === 1 && (
                    <>
                      <div className="row text-center mb-2">
                        <h2>Define Your Search</h2>
                        <p className="fs-19 fw-normal text-gray">
                          Describe the role or directly auto-generate a JD and
                          get AI-suggested filters
                        </p>
                      </div>
                      <div className="pricing-content rounded bg-light mb-3">
                        <div className="price-hdr">
                          <h6 className="fs-14 fw-medium w-100">
                            <i className="fa-solid fa-lightbulb ms-1 text-primary"></i>{" "}
                            Describe the Role & Search Parameters
                          </h6>
                        </div>
                        {/* Hidden field for RHF */}
                        <input
                          type="hidden"
                          {...register("industries", {
                            validate: (v) =>
                              v.length > 0 || "Select at least one industry",
                          })}
                        />

                        <textarea
                          id="role_description"
                          className="form-control"
                          rows="3"
                          placeholder="Describe the role you're searching for... (e.g., 'Looking for a VP of Engineering with experience in fintech and SaaS platforms') or just click the button below to auto generate JD and filters for industries, functions, seniority."
                          value={generatedRoleDescription || ""}
                          onChange={(e) => {
                            setGeneratedRoleDescription(e.target.value);
                          }}
                        ></textarea>

                        {/* <button
                          type="button"
                          className="btn btn-outline-secondary mt-1"
                          onClick={() => suggestIndustries()}
                          disabled={SuggestionLoader}
                        >
                          <i className="fa-solid fa-wand-magic-sparkles"></i>{" "}
                          Suggest Industries
                          {SuggestionLoader && (
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                          )}
                        </button> */}
                        <button
                          type="button"
                          className="btn btn-outline-secondary mt-1 ms-1"
                          onClick={() => getRoleJD(id)}
                          disabled={JdLoader}
                        >
                          <i className="fa-solid fa-wand-magic-sparkles me-1"></i>
                          Generate JD & Suggest Filters
                          {JdLoader && (
                            <span
                              className="spinner-border spinner-border-sm ms-1"
                              role="status"
                              aria-hidden="true"
                            ></span>
                          )}
                        </button>
                      </div>
                      <div className="row">
                        <hr style={{ opacity: 1 }} />
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="text-start">
                            <h6 className="fs-14 fw-medium w-100">
                              Or select manually
                              {errors.industries && (
                                <small className="text-danger d-block ms-2 fs-10 mt-1">
                                  <i>{`[${errors.industries.message}]`}</i>
                                </small>
                              )}
                            </h6>
                          </div>
                          <div className="text-end">
                            <button
                              type="button"
                              className="btn btn-primary"
                              onClick={() => {
                                setPage(0);
                                setHasMore(true);
                                setLoading(false);
                                resetFilters();
                                setCompanies([]);
                                get_companies(0);
                                setTotalCompanies(0);
                                goToStep(2);
                              }}
                            >
                              Next{" "}
                              <i className="fa-solid fa-chevron-right ms-1"></i>
                            </button>
                          </div>
                        </div>
                        {updatedIndustries.map((id) => (
                          <div
                            key={id}
                            className="col-md-1 chip bg-primary mt-1 mb-1 ms-1"
                            onClick={() => toggle(id)}
                          >
                            {industryIdMap[id]}
                            <span className="chip-closebtn">&times;</span>
                          </div>
                        ))}

                        <div className="chat-search search-wrap contact-search visible-chat mt-2 mb-2">
                          <div className="border rounded p-3">
                            {/* Search Input */}
                            <div className="mb-3">
                              <span
                                style={{
                                  position: "absolute",
                                  right: "50px",
                                  marginTop: "8px",
                                }}
                              >
                                <i className="fa-solid fa-magnifying-glass"></i>
                              </span>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Search industries..."
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                              />
                            </div>

                            {/* Checkbox Grid */}
                            <div className="row border rounded p-2 g-2">
                              <div className="accordion" id="industryAccordion">
                                {filteredIndustries.length ? (
                                  filteredIndustries.map((industry, i) => {
                                    const allSubs = getAllSubsFromMains(
                                      industry.mains,
                                    );
                                    const selectedCount =
                                      getSelectedCount(allSubs);
                                    const totalCount = allSubs.length;
                                    return (
                                      <div
                                        className="accordion-item"
                                        key={industry.label}
                                      >
                                        {/* LEVEL 1 */}
                                        <h2 className="d-flex flex-sm-row-reverse align-items-center">
                                          <button
                                            className="accordion-button collapsed"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target={`#lvl1-${i}`}
                                          >
                                            <i className="fa-solid fa-chevron-right me-sm-2 arrow-icon"></i>
                                            {industry.label}
                                          </button>
                                          <span
                                            className={`fs-12 fw-medium ${
                                              totalCount === 0
                                                ? "text-muted"
                                                : "text-primary"
                                            }`}
                                            style={{
                                              position: "absolute",
                                              zIndex: "999",
                                              marginRight: "10px",
                                            }}
                                          >
                                            ({selectedCount}/{totalCount})
                                          </span>
                                          <span
                                            className="text-primary fs-12 fw-medium ms-2 width-100"
                                            role="button"
                                            onClick={() =>
                                              toggleMajor(industry.mains)
                                            }
                                            style={{
                                              position: "absolute",
                                              zIndex: "999",
                                              marginRight: "20px",
                                            }}
                                          >
                                            {isAllMajorSelected(industry.mains)
                                              ? "Unselect all"
                                              : "Select all"}
                                          </span>
                                        </h2>

                                        <div
                                          id={`lvl1-${i}`}
                                          className={`accordion-collapse collapse ${
                                            search ? "show" : ""
                                          }`}
                                          data-bs-parent="#industryAccordion"
                                        >
                                          <div className="accordion-body p-2">
                                            {/* LEVEL 2 */}
                                            {industry.mains.map((main, j) => (
                                              <div
                                                className="accordion mb-2"
                                                key={main.label}
                                              >
                                                <div className="accordion-item">
                                                  <div className="d-flex flex-sm-row-reverse align-items-center">
                                                    <button
                                                      className="accordion-button collapsed fs-14 flex-grow-1"
                                                      type="button"
                                                      data-bs-toggle="collapse"
                                                      data-bs-target={`#lvl2-${i}-${j}`}
                                                    >
                                                      <i className="fa-solid fa-chevron-right me-sm-2 arrow-icon1"></i>
                                                      {main.label}
                                                    </button>
                                                    <span
                                                      className={`fs-12 fw-medium ${
                                                        main.subs.length === 0
                                                          ? "text-muted"
                                                          : "text-primary"
                                                      }`}
                                                      style={{
                                                        position: "absolute",
                                                        zIndex: "999",
                                                      }}
                                                    >
                                                      (
                                                      {
                                                        main.subs.filter((s) =>
                                                          selectedIndustries.includes(
                                                            s.id,
                                                          ),
                                                        ).length
                                                      }
                                                      /{main.subs.length})
                                                    </span>
                                                    <span
                                                      className="text-primary fs-12 fw-medium ms-2 width-100"
                                                      role="button"
                                                      onClick={() =>
                                                        toggleMain(main.subs)
                                                      }
                                                      style={{
                                                        position: "absolute",
                                                        zIndex: "999",
                                                      }}
                                                    >
                                                      {isAllSelected(main.subs)
                                                        ? "Unselect all"
                                                        : "Select all"}
                                                    </span>
                                                  </div>

                                                  <div
                                                    id={`lvl2-${i}-${j}`}
                                                    className={`accordion-collapse collapse ${
                                                      search ? "show" : ""
                                                    }`}
                                                  >
                                                    <div className="accordion-body">
                                                      {/* LEVEL 3 */}
                                                      <div className="row g-2">
                                                        {main.subs.map(
                                                          (sub, k) => (
                                                            <div
                                                              className="col-md-6"
                                                              key={k}
                                                            >
                                                              <label className="d-flex align-items-center gap-2 cursor-pointer">
                                                                <input
                                                                  type="checkbox"
                                                                  checked={selectedIndustries?.includes(
                                                                    sub.id,
                                                                  )}
                                                                  onChange={() =>
                                                                    toggle(
                                                                      sub.id,
                                                                    )
                                                                  }
                                                                />
                                                                <span>
                                                                  {sub.label}
                                                                </span>
                                                              </label>
                                                            </div>
                                                          ),
                                                        )}
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            ))}
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })
                                ) : (
                                  <div className="text-muted text-center">
                                    No results found
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="text-end">
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={() => {
                            setPage(0);
                            setHasMore(true);
                            setLoading(false);
                            resetFilters();
                            setCompanies([]);
                            get_companies(0);
                            setTotalCompanies(0);
                            goToStep(2);
                          }}
                        >
                          Next{" "}
                          <i className="fa-solid fa-chevron-right ms-1"></i>
                        </button>
                      </div>
                    </>
                  )}

                  {/* STEP 2 */}
                  {step === 2 && (
                    <>
                      <div className="d-flex justify-content-between align-items-center text-center mb-2">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={() => setStep(1)}
                        >
                          <i className="fa-solid fa-chevron-left me-1"></i>{" "}
                          Previous
                        </button>

                        <h2>Generated Companies</h2>

                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={() => goToStep(3)}
                        >
                          Next{" "}
                          <i className="fa-solid fa-chevron-right ms-1"></i>
                        </button>
                      </div>

                      <div className="row">
                        <hr style={{ opacity: 1 }} />
                        <h6 className="fs-14 fw-medium w-100 d-flex">
                          {errors.companies && (
                            <small className="text-danger d-block ms-2 fs-10 mt-1">
                              <i>{`[${errors.companies.message}]`}</i>
                            </small>
                          )}
                        </h6>
                        <div className="chat-search search-wrap contact-search visible-chat mt-2 mb-2">
                          <div className="border rounded p-3">
                            {companyNames.length > 0 && (
                              <div className="d-flex flex-wrap gap-2 mt-2">
                                {companyNames.map((name, index) => (
                                  <span
                                    key={index}
                                    className="chip bg-primary text-white d-flex align-items-center"
                                  >
                                    {name}
                                    <span
                                      className="chip-closebtn ms-2"
                                      role="button"
                                      onClick={() => removeCompanyName(name)}
                                    >
                                      &times;
                                    </span>
                                  </span>
                                ))}
                              </div>
                            )}

                            {/* Search Input */}
                            <div className="mb-3">
                              <span
                                style={{
                                  position: "absolute",
                                  right: "50px",
                                  marginTop: "8px",
                                }}
                              >
                                <i className="fa-solid fa-magnifying-glass"></i>
                              </span>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Search Companies... (comma separated)"
                                value={companyInput}
                                onChange={(e) =>
                                  setCompanyInput(e.target.value)
                                }
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    e.preventDefault();

                                    if (!companyInput.trim()) {
                                      setHasMore(true);
                                      setPage(0);
                                      setCompanies([]);
                                      get_companies(0, appliedFilters);
                                      return;
                                    }

                                    const names = companyInput
                                      .split(",")
                                      .map((n) => n.trim())
                                      .filter(Boolean);

                                    if (!names.length) return;

                                    const updatedNames = [
                                      ...new Set([...companyNames, ...names]),
                                    ];

                                    setCompanyNames(updatedNames);
                                    setCompanyInput("");

                                    const updatedFilters = {
                                      ...appliedFilters,
                                      names: updatedNames,
                                    };

                                    setAppliedFilters(updatedFilters);
                                    setCompanies([]);
                                    setPage(0);
                                    setHasMore(true); // 🔥 IMPORTANT

                                    get_companies(0, updatedFilters);
                                  }
                                }}
                              />
                            </div>

                            <input
                              type="hidden"
                              {...register("companies", {
                                validate: (v) =>
                                  v !== 0 ||
                                  "There must be at least one company in result",
                              })}
                            />

                            {/* Checkbox Grid */}
                            <div className="mb-3">
                              <div className="d-flex justify-content-between">
                                <div className="d-flex align-items-center mb-3">
                                  <span className="fw-normal">
                                    {" "}
                                    Showing: {companies.length}/{totalCompanies}
                                  </span>
                                  {(revenueFilter.length > 0 ||
                                    sizeFilter.length > 0) && (
                                    <button
                                      className="btn btn-outline-primary btn-sm ms-2"
                                      onClick={resetFilters}
                                    >
                                      Reset Filters
                                    </button>
                                  )}
                                </div>
                                <div className="d-flex align-items-center justify-content-end mb-3">
                                  <span>Filter By : </span>
                                  <div className="dropdown ms-2 me-2">
                                    <Select
                                      options={cr_options}
                                      isMulti
                                      placeholder="Revenue"
                                      classNamePrefix="react-select"
                                      onChange={handleRevenueChange}
                                      value={cr_options.filter((o) =>
                                        revenueFilter.includes(o.value),
                                      )}
                                    />
                                  </div>
                                  <div className="dropdown">
                                    <Select
                                      options={sz_options}
                                      isMulti
                                      placeholder="Sizes"
                                      onChange={handleSizeChange}
                                      classNamePrefix="react-select"
                                      value={sz_options.filter((o) =>
                                        sizeFilter.includes(o.value),
                                      )}
                                    />
                                  </div>
                                  <button
                                    className="btn btn-outline-primary btn-sm ms-1"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      applyFilters();
                                    }}
                                  >
                                    Apply Filters
                                  </button>
                                </div>
                              </div>
                              <div
                                className="row border rounded p-2"
                                style={{
                                  maxHeight: "500px",
                                  overflowY: "auto",
                                }}
                                onScroll={handleScroll}
                              >
                                <div className="row g-3">
                                  {/* Companies */}
                                  {companies.length > 0 ? (
                                    companies.map((company, i) => (
                                      <div
                                        className="col-xl-3 col-lg-4 col-md-6"
                                        key={i}
                                      >
                                        <div className="card h-100">
                                          <div className="card-body text-center">
                                            {/* <input
                                              type="checkbox"
                                              className="form-check-input mb-2 float-sm-start"
                                            /> */}

                                            <img
                                              src={
                                                company.logoUrl ||
                                                `${PINE_BASE_URL}/files/companyLogo/nologo.png`
                                              }
                                              className="avatar avatar-xl avatar-rounded border"
                                              alt={company.name}
                                            />

                                            <h6 className="mt-2">
                                              {company.name}
                                            </h6>

                                            <p className="fs-12 text-muted">
                                              <a
                                                target="_blank"
                                                href={`//${company.fqdn}`}
                                              >
                                                <i className="fa-solid fa-globe me-1"></i>
                                                {company.fqdn || "N/A"}
                                              </a>
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    ))
                                  ) : loading ? (
                                    <div className="text-center mt-2">
                                      <span className="spinner-border spinner-border-sm"></span>
                                    </div>
                                  ) : (
                                    <div className="text-center text-muted">
                                      No companies found
                                    </div>
                                  )}

                                  {/* Infinite scroll loader */}
                                  {loading &&
                                    hasMore &&
                                    companies.length > 0 && (
                                      <div className="text-center mt-2">
                                        <span className="spinner-border spinner-border-sm"></span>
                                      </div>
                                    )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex justify-content-between">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={() => setStep(1)}
                        >
                          <i className="fa-solid fa-chevron-left me-1"></i>{" "}
                          Previous
                        </button>

                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={() => goToStep(3)}
                        >
                          Next{" "}
                          <i className="fa-solid fa-chevron-right ms-1"></i>
                        </button>
                      </div>
                    </>
                  )}

                  {/* STEP 3 */}
                  {step === 3 && (
                    <>
                      <div className="d-flex justify-content-between align-items-center text-center mb-2">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={() => setStep(2)}
                        >
                          <i className="fa-solid fa-chevron-left me-1"></i>{" "}
                          Previous
                        </button>

                        <span>
                          <h2>Select Contact Geographies</h2>
                          <p className="fs-19 fw-normal text-gray">
                            Select entire regions or specific countries
                          </p>
                        </span>
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={() => goToStep(4)}
                        >
                          Next{" "}
                          <i className="fa-solid fa-chevron-right ms-1"></i>
                        </button>
                      </div>
                      <div className="pricing-content rounded mb-3">
                        <div className="price-hdr">
                          <h6 className="fs-14 fw-medium w-100">
                            <i className="fa-solid fa-globe ms-1"></i> Quick
                            Select by Region
                          </h6>
                        </div>
                        {/* Hidden field for RHF */}
                        <input
                          type="hidden"
                          {...register("countries", {
                            validate: (v) => {
                              if (v.length === 0) {
                                window.scrollTo(0, 0);
                                return "Select at least one country";
                              }
                            },
                          })}
                        />

                        <div className="row">
                          {dataregions &&
                          Object.keys(dataregions).length > 0 ? (
                            Object.keys(dataregions).map(
                              (regionName, index) => (
                                <>
                                  <div
                                    key={regionName}
                                    className="col-md-1 chip bg-primary mt-1 mb-1 ms-1"
                                    onClick={() => toggleRegion(regionName)}
                                  >
                                    {regionName}
                                  </div>
                                </>
                              ),
                            )
                          ) : (
                            <>No Region Found</>
                          )}
                        </div>
                      </div>
                      <div className="row">
                        <hr style={{ opacity: 1 }} />
                        <h6 className="fs-14 fw-medium w-100 d-flex">
                          {updatedCountries.length > 0
                            ? "Selected countries"
                            : "Or select specific countries"}
                          {errors.countries && (
                            <small className="text-danger d-block ms-2 fs-10 mt-1">
                              <i>{`[${errors.countries.message}]`}</i>
                            </small>
                          )}
                        </h6>
                        {updatedCountries.length > 0 && (
                          <div className="row">
                            {updatedCountries.map((item) => (
                              <>
                                <div
                                  className="col-md-1 chip bg-primary mt-1 mb-1 ms-1"
                                  onClick={() => toggleCountries(item)}
                                  key={item}
                                >
                                  {item}
                                  <span className="chip-closebtn">&times;</span>
                                </div>
                              </>
                            ))}
                          </div>
                        )}
                        <div className="chat-search search-wrap contact-search visible-chat mt-2 mb-2">
                          <div
                            className="border rounded p-3"
                            style={{
                              maxHeight: "500px",
                              overflow: "overlay",
                            }}
                          >
                            {/* Search Input */}
                            <div className="mb-3">
                              <span
                                style={{
                                  position: "absolute",
                                  right: "50px",
                                  marginTop: "8px",
                                }}
                              >
                                <i className="fa-solid fa-magnifying-glass"></i>
                              </span>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Search locations..."
                                value={searchCountry}
                                onChange={(e) =>
                                  setSearchCountry(e.target.value)
                                }
                              />
                            </div>

                            {/* Checkbox Grid */}
                            {filteredCountriesByRegion.length ? (
                              filteredCountriesByRegion.map((group, index) => (
                                <div key={index} className="mb-3">
                                  {/* REGION HEADER */}
                                  <h6 className="fw-semibold text-primary mb-3">
                                    {group.region}
                                  </h6>

                                  <div className="row border rounded p-2 g-2">
                                    {group.countries.map((item, i) => (
                                      <div className="col-md-6" key={i}>
                                        <label className="d-flex align-items-center gap-2 p-2 div-focus cursor-pointer">
                                          <input
                                            type="checkbox"
                                            checked={selectedCountries?.includes(
                                              item.label,
                                            )}
                                            onChange={() =>
                                              toggleCountries(item.label)
                                            }
                                          />
                                          <span>{item.label}</span>
                                        </label>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              ))
                            ) : (
                              <div className="text-muted text-center">
                                No results found
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="d-flex justify-content-between">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={() => setStep(2)}
                        >
                          <i className="fa-solid fa-chevron-left me-1"></i>{" "}
                          Previous
                        </button>

                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={() => goToStep(4)}
                        >
                          Next{" "}
                          <i className="fa-solid fa-chevron-right ms-1"></i>
                        </button>
                      </div>
                    </>
                  )}

                  {/* STEP 4 */}
                  {step === 4 && (
                    <>
                      <div className="d-flex justify-content-between align-items-center text-center mb-2">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={() => setStep(3)}
                        >
                          <i className="fa-solid fa-chevron-left me-1"></i>{" "}
                          Previous
                        </button>

                        <span>
                          <h2>Select Functions & Seniority</h2>
                          <p className="fs-19 fw-normal text-gray">
                            Choose the roles and seniority levels you're
                            targeting
                          </p>
                        </span>

                        <button type="submit" className="btn btn-primary">
                          <i className="fa-solid fa-user-group ms-1"></i> Find
                          Talent
                        </button>
                      </div>
                      <input
                        type="hidden"
                        {...register("seniority", {
                          validate: (value) =>
                            value.length > 0 ||
                            "Please select at least one seniority level",
                        })}
                      />
                      <div className="row g-2 mb-2 p-2">
                        <h6 className="fw-semibold text-primary mb-3">
                          Seniority Levels{" "}
                          {errors.seniority && (
                            <span className="text-danger">{`[${errors.seniority.message}]`}</span>
                          )}
                        </h6>
                        <div className="row border rounded p-2">
                          {ContactSeniority.map((sub, k) => (
                            <div className="col-md-6" key={k}>
                              <label className="d-flex align-items-center gap-2 p-2 div-focus cursor-pointer">
                                <input
                                  type="checkbox"
                                  checked={selectedSeniority?.includes(sub.id)}
                                  onChange={() => toggleSeniority(sub.id)}
                                />
                                <span>
                                  {sub.name
                                    ?.toLowerCase()
                                    .replace(/\b\w/g, (char) =>
                                      char.toUpperCase(),
                                    )}
                                </span>
                              </label>
                            </div>
                          ))}
                        </div>
                      </div>
                      <div className="row g-2 mb-2 p-2">
                        <h6 className="fw-semibold text-primary mb-3">
                          Functions{" "}
                          {errors.departments && (
                            <span className="text-danger">{`[${errors.departments.message}]`}</span>
                          )}
                        </h6>
                        <input
                          type="hidden"
                          {...register("departments", {
                            validate: (value) =>
                              value.length > 0 ||
                              "Please select at least one function",
                          })}
                        />
                        <div className="row border rounded p-2">
                          {ContactDepartments.map((sub, k) => (
                            <div className="col-md-6 div-focus" key={k}>
                              <label className="d-flex align-items-center gap-2 p-2 div-focus cursor-pointer">
                                <input
                                  type="checkbox"
                                  checked={selectedDepartments?.includes(sub)}
                                  onChange={() => toggleDepartments(sub)}
                                />
                                <span>
                                  {sub
                                    ?.toLowerCase()
                                    .replace(/\b\w/g, (char) =>
                                      char.toUpperCase(),
                                    )}
                                </span>
                              </label>
                            </div>
                          ))}
                        </div>
                      </div>
                      <div className="d-flex justify-content-between">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={() => setStep(3)}
                        >
                          <i className="fa-solid fa-chevron-left me-1"></i>{" "}
                          Previous
                        </button>

                        <button type="submit" className="btn btn-primary">
                          <i className="fa-solid fa-user-group ms-1"></i> Find
                          Talent
                        </button>
                      </div>
                    </>
                  )}

                  {step === 5 && (
                    <>
                      <div className="row border rounded p-2">
                        <input
                          type="text"
                          className="form-control mb-2"
                          placeholder="Search with job titles comma seprated"
                          value={jobTitles}
                          onChange={(e) => {
                            setJobTitles(e.target.value);
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();

                              if (!jobTitles.trim()) {
                                return;
                              }

                              const names = jobTitles
                                .split(",")
                                .map((n) => n.trim())
                                .filter(Boolean);

                              if (!names.length) return;

                              setBackupContacts(contacts);

                              setJobNames(names);
                              setContacts([]); // clear UI immediately
                              setHasMoreContacts(true);
                              setContactPage(0);

                              const filters = {
                                ...contactFilters,
                                jobTitles: names,
                              };

                              get_contacts(0, filters, true);
                            }
                          }}
                        />
                        <div className="d-flex justify-content-between">
                          <span className="fw-normal">
                            {" "}
                            Showing: {contacts.length}/{totalContacts}
                          </span>
                          {SelectedContacts.length > 0 && (
                            <button
                              type="button"
                              className="btn btn-sm btn-primary float-end"
                              onClick={() => mapCandidates()}
                            >
                              Add To Workstation
                            </button>
                          )}
                        </div>
                        <div
                          className="row g-3 contact-scroll border ms-sm-0"
                          onScroll={handleContactScroll}
                          style={{
                            maxHeight: "70vh",
                            overflowY: "auto",
                          }}
                        >
                          {contacts.length ? (
                            contacts.map((contact, i) => (
                              <div
                                className="col-xl-3 col-lg-4 col-md-6"
                                key={contact.id || i}
                              >
                                <div className="card h-100">
                                  <div className="card-body text-center d-flex flex-sm-column">
                                    <div
                                      className={`d-flex ${
                                        contact?.candidate_id
                                          ? "justify-content-md-between"
                                          : "flex-lg-row-reverse"
                                      } `}
                                    >
                                      {contact?.candidate_id && (
                                        <input
                                          type="checkbox"
                                          name="candidate_id"
                                          onClick={() => {
                                            toggleAddToWorkstaion(
                                              contact.candidate_id,
                                            );
                                          }}
                                        />
                                      )}
                                      {contact.socialLinks && (
                                        <a
                                          href={contact.socialLinks.linkedin}
                                          target="_blank"
                                        >
                                          <i className="fa-brands fa-linkedin"></i>
                                        </a>
                                      )}
                                    </div>

                                    <div>
                                      {/* Name */}
                                      <h6 className="mb-1">
                                        {contact.name || "N/A"}
                                      </h6>
                                      {contact.location && (
                                        <span className="badge bg-pink-transparent fs-10 fw-medium mb-1">
                                          {contact.location.country}
                                        </span>
                                      )}

                                      {/* Designation */}
                                      <p className="fs-10 text-muted mb-1">
                                        {contact.jobTitle || "—"}
                                      </p>

                                      {/* Company */}
                                      <p className="fs-10 text-muted mb-1">
                                        <i className="fa-solid fa-building me-1"></i>
                                        {contact.companyName || "—"}
                                      </p>

                                      {/* SHOW DETAILS BUTTON */}
                                      {!contact.enriched &&
                                        !contact.enrichLoading && (
                                          <button
                                            className="btn btn-sm btn-outline-primary"
                                            onClick={() =>
                                              handleEnrich(contact)
                                            }
                                            disabled={
                                              contact.enrichLoading ||
                                              DisableShowDetails
                                            }
                                          >
                                            Show Details
                                          </button>
                                        )}

                                      {contact.enrichLoading && (
                                        <span className="spinner-border spinner-border-sm" />
                                      )}

                                      {/* ENRICHED DATA */}
                                      {contact.enriched && (
                                        <div className="mt-1 text-start fs-12">
                                          {contact.emailAddresses &&
                                          contact.emailAddresses.length > 0 ? (
                                            <div className="text-center">
                                              {contact.emailAddresses
                                                .map((email, i) => email.email)
                                                .join(", ")}
                                            </div>
                                          ) : (
                                            <>
                                              <div className="text-center text-danger">
                                                No Email Found
                                              </div>
                                            </>
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))
                          ) : contactLoading ? (
                            <div className="text-center w-100 mt-3">
                              <span className="spinner-border spinner-border-sm"></span>
                            </div>
                          ) : (
                            <div className="text-center text-muted w-100 mt-3">
                              No contacts found
                            </div>
                          )}
                        </div>

                        {/* BOTTOM LOADER FOR SCROLL */}
                        {hasMoreContacts && contactLoading && (
                          <div className="text-center mt-2">
                            <span className="spinner-border spinner-border-sm"></span>
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
